/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';

export const calendarEventParticipantDtoSchema = z.object({ "meetingJoinedAt": z.string().datetime().nullish(), "meetingLeftAt": z.string().datetime().nullish(), "participantName": z.string().nullish() });
export type CalendarEventParticipantDto = z.infer<typeof calendarEventParticipantDtoSchema>;
